"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _propTypes = _interopRequireDefault(require("prop-types"));
var _hooks = require("../../hooks");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const RenderSettingValue = props => {
  const {
    currentSetting: setting,
    intlKey: passedIntlKey,
    intlNS: passedIntlNS,
    labelOverrides = {},
    refdata,
    // TODO ... can we get away without passing these in now, using useRefdata?
    templates // TODO ... can we get away without passing these in now, using useTemplates?
  } = props;
  const kintIntl = (0, _hooks.useKintIntl)(passedIntlKey, passedIntlNS);
  const NoCurrentValue = kintIntl.formatKintMessage({
    id: 'settings.noCurrentValue',
    overrideValue: labelOverrides === null || labelOverrides === void 0 ? void 0 : labelOverrides.noCurrentValue
  });
  const defaultText = "[".concat(kintIntl.formatKintMessage({
    id: 'settings.default',
    overrideValue: labelOverrides === null || labelOverrides === void 0 ? void 0 : labelOverrides.default
  }), "]");
  switch (setting.settingType) {
    case 'Refdata':
      {
        if (setting.value) {
          var _refdata$filter$0$lab, _refdata$filter$;
          return (_refdata$filter$0$lab = refdata === null || refdata === void 0 || (_refdata$filter$ = refdata.filter(obj => obj.value === setting.value)[0]) === null || _refdata$filter$ === void 0 ? void 0 : _refdata$filter$.label) !== null && _refdata$filter$0$lab !== void 0 ? _refdata$filter$0$lab : null;
        }
        if (setting.defValue) {
          var _refdata$filter$2;
          const defValue = refdata === null || refdata === void 0 || (_refdata$filter$2 = refdata.filter(obj => obj.value === setting.defValue)[0]) === null || _refdata$filter$2 === void 0 ? void 0 : _refdata$filter$2.label;
          return "".concat(defaultText, " ").concat(defValue);
        }
        return NoCurrentValue;
      }
    case 'Password':
      {
        if (setting.value) {
          return '********';
        }
        if (setting.defValue) {
          return "".concat(defaultText, " ********");
        }
        return NoCurrentValue;
      }
    case 'Template':
      {
        const templateValue = templates.filter(obj => {
          const settingId = setting.value || setting.defValue;
          return obj.id === settingId;
        })[0];
        return (templateValue === null || templateValue === void 0 ? void 0 : templateValue.name) || NoCurrentValue;
      }
    default:
      {
        if (setting.value) {
          return setting.value;
        }
        if (setting.defValue) {
          return "".concat(defaultText, " ").concat(setting.defValue);
        }
        return NoCurrentValue;
      }
  }
};
RenderSettingValue.propTypes = {
  currentSetting: _propTypes.default.object,
  intlKey: _propTypes.default.string,
  intlNS: _propTypes.default.string,
  labelOverrides: _propTypes.default.object,
  refdata: _propTypes.default.arrayOf(_propTypes.default.object),
  templates: _propTypes.default.arrayOf(_propTypes.default.object)
};
var _default = exports.default = RenderSettingValue;